import './header-row.styl'
import React from 'react'
import { Row, Col } from 'react-bootstrap'


class Component extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    let { id, name, click, selected } = this.props

    if (typeof click !== 'function') {
      click = () => {}
    }

    let classNames = 'header-row'

    if (selected) {
      classNames += ' active'
    }

    return (
      <div className={classNames} onClick={ (e) => { click(e) } }>
        <Row>
          <Col xs={9}>{ name }</Col>
          <Col xs={3} className="align-right"><i className="fa fa-check" /></Col>
        </Row>
      </div>
    )
  }
}

export default Component



// WEBPACK FOOTER //
// ./components/Headers/header-row.js